export const VENDOR_LIST = "SPORT_VENDOR_LIST";
export const SPORT_GAME_ACCESS = "SPORT_GAME_ACCESS";
